import { Box, Center, Flex, Image } from '@mantine/core';
import type { FC, ReactNode } from 'react';

interface FullScreenSplitProps {
  children: ReactNode;
  /**
   * Optional side image, managed per language in the CMS on
   * `content_login_translations.image` / `content_signup_translations.image`.
   * When it is not set the layout stays the plain centred panel it has always been.
   */
  imageSrc?: string;
}

export const CenterLayout: FC<FullScreenSplitProps> = ({ children, imageSrc }) => {
  const content = (
    <Box
      py={76}
      style={{
        backgroundColor: '#ffffff',
        minHeight: 'inherit',
      }}
      w="100%"
    >
      <Center>{children}</Center>
    </Box>
  );

  if (!imageSrc) return content;

  return (
    <Flex style={{ minHeight: 'inherit' }} w="100%">
      {/* An <img> rather than a CSS background: only an <img> can be loaded without cookies. */}
      <Box pos="relative" visibleFrom="md" w="40%">
        <Image
          alt=""
          crossOrigin="anonymous"
          fit="cover"
          h="100%"
          pos="absolute"
          src={imageSrc}
          style={{ inset: 0 }}
          w="100%"
        />
      </Box>
      <Box style={{ minHeight: 'inherit' }} w="100%">
        {content}
      </Box>
    </Flex>
  );
};
